export const MAX_DOWNPAYMENT_THRESHOLD = 9999999;
export const MAX_SELLING_PRICE_THRESHOLD = 9999999;
export const MAX_RETAIL_PRICE_THRESHOLD = 9999999;
export const NUMERIC_MAX_VALUE_MESSAGE = 'Value should be less than 1 million';
